import { d as h, b as bem } from './p-c44c2366.js';
import { C as CosmosLiveIconAnimated } from './p-c4ad5657.js';

const generateClassNames$1 = bem('card-badge');
const CardBadge = ({ text, isLive }) => {
    return (h("div", { class: generateClassNames$1({ 'is-live': isLive }), part: "badge" },
        isLive && h(CosmosLiveIconAnimated, { class: generateClassNames$1('icon') }),
        h("cosmos-text", { class: generateClassNames$1('label'), clamp: 1, appearance: "light", size: "xx-small", weight: "bold", exportparts: "base: badge-text" },
            h("span", { id: "badge", "aria-label": text }, text))));
};

const generateClassNames = bem('card-favorite');
const CardFavorite = ({ isFavorite, isFavoritable, favoriteLabel, class: classname, onClick, }) => {
    return (isFavoritable && (h("cosmos-button", { appearance: "light", "button-title": favoriteLabel, class: [generateClassNames({ persistent: isFavorite }), classname].join(' '), exportparts: "base: favorite-button", kind: "cover-up", onClick: onClick, 
        /* Prevent the button to gain focus on click
        and stay visible event when the cursor leave the card */
        onMouseDown: (e) => e.preventDefault(), shape: "circle", size: "small" }, isFavorite ? h("cosmos-icon-star-filled", { slot: "icon" }) : h("cosmos-icon-star", { slot: "icon" }))));
};

export { CardFavorite as C, CardBadge as a };
